import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const Step = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: center;
  flex: 1;

  h3 {
    color: ${({ theme }) => theme.colors.primary};
    font-size: ${({ theme }) => theme.font.sizes.large};
    text-align: center;
    position: absolute;
    top: 10%;
    left: 50%;
    width: 100%;
    display: block;
    transform: translateY(-50%) translateX(-50%);
  }
`

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;

  label:not(:first-child) {
    margin-top: 12px;
  }
`

export const HospitalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto 0;
`

export const HospitalInfo = styled.div<{ selected?: boolean }>`
  width: 100%;
  height: ${({ selected }) => (selected ? '217px' : '77px')};
  position: relative;
  padding: 12px 24px;
  border: 1px solid ${({ theme }) => theme.colors.gray};
  border-radius: ${({ theme }) => theme.border.radius.small};
  transition: cubic-bezier(0, 0.54, 0, 0.82) 300ms;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  overflow: hidden;

  h4 {
    color: ${({ theme }) => theme.colors.gray};
    font-size: 18px;
    font-weight: 600;
  }

  span {
    color: ${({ theme }) => theme.colors.lightGray};
    white-space: ${({ selected }) => (selected ? 'normal' : 'nowrap')};

    text-overflow: ellipsis;
    display: inline-block;
    max-width: 100%;
    text-align: left !important;
  }

  p {
    text-align: left !important;
  }

  p:first-of-type {
    margin: ${({ selected }) => (selected ? 'auto' : '6px')} 0 auto 0;
  }

  & + div {
    margin-top: 12px;
  }

  & > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    max-width: 100%;
    overflow: hidden;
  }

  header {
    max-width: 98%;
    overflow: hidden;
    display: grid;
    grid-template-columns: 20px auto;
    gap: 12px;
    svg {
      margin-top: 2px;
    }
  }

  &:after {
    content: '';
    border: solid ${({ theme }) => theme.colors.primary};
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 4px;
    position: absolute;
    top: 36px;
    right: 15px;
    transform: rotate(${({ selected }) => (selected ? '-135deg' : '45deg')})
      translateY(-50%) translateX(-50%);
  }
`
